import { render, staticRenderFns } from "./ModalSubTipos.vue?vue&type=template&id=7fa176ba"
import script from "./ModalSubTipos.vue?vue&type=script&lang=js"
export * from "./ModalSubTipos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports